<template lang="pug">
.accept-status-modal
  b-modal(v-model="_value" size="md" no-close-on-backdrop no-close-on-esc @ok="ok" @cancel="cancel")
    div(slot="modal-title")
      .d-flex.flex-column
        span 受付状態を「受付中」に変更します。
        span 回答期限を設定してください。
        span よろしければOKボタンを選択してください。

    .accept-status-modal-body
      .box-body.register-body
        .questionnaire-contents
          FormCheck(v-model="enableAnswerLimit" key-name="" name="enable-answer-limit" label="回答期限を設定する")
          FormDatetimePicker(v-if="enableAnswerLimit == true" v-model="replyLimit" :date.sync="replyLimitDate" :time.sync="replyLimitTime"
            placeholder="回答期限" key-name="日付・時間" name="answer-limit")

    .testmail-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }")
      .buttons
        button.btn.modal-ok-btn(type="button" @click="ok") OK
        button.btn.modal-cancel-btn(type="button" @click="cancel") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import FormCheck from "@/pc/components/forms/FormCheck.vue";
import FormDatetimePicker from "@/pc/components/forms/FormDatetimePicker.vue";

/**
 * ### 受付状態変更モーダル
 */
@Component({
  components: {
    FormCheck,
    FormDatetimePicker
  }
})
export default class AcceptStatusModal extends Vue {
  @Prop({
    default: () => {
      return false;
    }
  })
  value!: boolean;

  /** 回答期限を設定するか */
  enableAnswerLimit: boolean = false;
  /** 期日 */
  replyLimit: number | null = null;
  /** 期日(日付) */
  replyLimitDate: string = "";
  /** 期日(時間) */
  replyLimitTime: string = "";

  public mounted(): void {
    this.init();
    return;
  }

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  public ok(): void {
    this.$emit("ok", this.replyLimit);
    this.init();
    return;
  }

  public cancel(): void {
    this.$emit("cancel", this.enableAnswerLimit == true ? this.replyLimit : null);
    this.init();
    return;
  }

  public init(): void {
    this.enableAnswerLimit = false;
    this.replyLimit = null;
    const replyLimitDate: Date = new Date();
    replyLimitDate.setDate(replyLimitDate.getDate() + 7);
    this.replyLimitDate = this.$dateUtil.convertDateToString(new Date(), "yyyy-mm-dd");
    this.replyLimitTime = "10:00:00";
    return;
  }
}
</script>
